module.exports = __webpack_public_path__ + "img/logo.4f0a95fa.png";